// Create basic homepage component

import { ReactElement } from "react"

import PublicHomepage from "./publicHomepage"
import UnapprovedUserHomepage from "./unapprovedUserHomepage"
import {
    DB_ASSESSOR_DEMAND,
    DB_ASSESSOR_GEN,
    DNO_APPROVED,
    ENA_SYS_ADMIN,
    INSTALLER,
    INSTALLER_APPROVED,
    LCT_MANU_APPROVED,
} from "../../constants/roles"
import { useGetUserData } from "../../hooks/useGetUserData"
import DnoHomepage from "../dnoPortal/dnoHomepage"
import InstallerHomepage from "../installerPortal/installerHomepage"
import ManufacturerHomepage from "../manufacturerPortal/manufacturerHomepage"
import SysAdminHomepage from "../sysAdmin/sysAdminHomepage"
import DemandAssessorHomepage from "../validatorsPortal/demandAssessorHomepage"
import GenerationAssessorHomepage from "../validatorsPortal/generationAssessorHomepage"

const HOMEPAGE_DISPATCHER: { [key: string]: ReactElement } = {
    [DNO_APPROVED]: <DnoHomepage />,
    [ENA_SYS_ADMIN]: <SysAdminHomepage />,
    [LCT_MANU_APPROVED]: <ManufacturerHomepage />,
    [DB_ASSESSOR_DEMAND]: <DemandAssessorHomepage />,
    [DB_ASSESSOR_GEN]: <GenerationAssessorHomepage />,
    [INSTALLER_APPROVED]: <InstallerHomepage />,
}

/*
/*
* Initial homepage component for user navigation
* If user is signed in and has a group listed within groupComponents, 
* they will be redirected to their dashboard 
* 
* example usage: <Homepage />
* @returns {ReactElement} React component
*/
const Homepage = (): ReactElement => {
    const { groups, showUnapprovedWarning, isAwaitingSetup, isSignedIn } =
        useGetUserData()

    if (isAwaitingSetup && isSignedIn) {
        return <UnapprovedUserHomepage awaitingSetUp />
    }

    const groupName = groups.find((group) => HOMEPAGE_DISPATCHER[group])
    if (groupName) {
        return HOMEPAGE_DISPATCHER[groupName]
    }

    const installerSoleTrader = groups.every(
        (installerGroup) => installerGroup === INSTALLER
    )
    if (installerSoleTrader) {
        return HOMEPAGE_DISPATCHER[INSTALLER_APPROVED]
    }

    if (showUnapprovedWarning) {
        return <UnapprovedUserHomepage awaitingSetUp={false} />
    }
    return <PublicHomepage />
}

export default Homepage
